module.exports = {
  methods: {
    setTitle(titleText) {
      document.title = `Honex - ${titleText}`;
    },
  },
};
